import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0007ba4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-listing" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "user-listing__user-title" }, "Статистика организации", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "user-listing__user-description" }, "по всем отчётам за период", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "divider" }

import { computed, PropType } from 'vue'
import { UserType } from '@/shared/types'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { EUserCard } from '@/entities/EUserCard'

interface Props {
  users: UserType[]
}


export default /*#__PURE__*/_defineComponent({
  props: {
    users: null
  },
  setup(__props: any) {

const props = __props as {
  users: UserType[]
}



const router = useRouter()
const route = useRoute()

const activeUserId = computed(() => Number(route.params.userId))

const organizationId = computed(
  (): string | string[] => route.params.organizationId
)

const isUserStatistic = computed(() => route.path.includes('/show'))
const isOrganizationPage = computed(() => route.path.includes('/organizations'))

const getOrganizationIdByUser = (userId: number): number => {
  const user = props.users.filter((user) => user.id === userId)[0]
  const organization = user.organization[0]

  return organization.id
}

const openUserStatisticPage = (userId: number): void => {
  try {
    const userOrganizationId =
      organizationId.value === 'all'
        ? getOrganizationIdByUser(userId)
        : organizationId.value

    router.push({
      name: 'UsersShowPage',
      params: {
        userId,
        organizationId: userOrganizationId,
      },
    })
  } catch {
    ElMessage({
      message: 'Врач не работает ни в одной организации',
      type: 'error',
    })
  }
}

const handleChooseUser = (userId: number): void => {
  if (isOrganizationPage.value) {
    router.push({
      name: 'OrganizationsShowPage',
      params: { organizationId: organizationId.value, userId },
    })
  } else {
    openUserStatisticPage(userId)
  }
}

const handleOpenOrganizationStatistic = (): void => {
  router.push({
    name: 'OrganizationStatisticPage',
    params: { organizationId: organizationId.value },
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isOrganizationPage))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "user-listing__user",
          onClick: handleOpenOrganizationStatistic
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["user-listing__user-content", {
          'user-listing__user-content--active': !_unref(isUserStatistic),
        }])
          }, _hoisted_4, 2),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_divider)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.users, (user) => {
      return (_openBlock(), _createBlock(_unref(EUserCard), {
        key: user.id,
        user: user,
        onClick: ($event: any) => (handleChooseUser(user.id)),
        active: _unref(activeUserId) === user.id
      }, null, 8, ["user", "onClick", "active"]))
    }), 128))
  ]))
}
}

})